import { render, staticRenderFns } from "./SecurityVerification.vue?vue&type=template&id=922e279a&scoped=true"
import script from "./SecurityVerification.vue?vue&type=script&lang=ts"
export * from "./SecurityVerification.vue?vue&type=script&lang=ts"
import style0 from "./SecurityVerification.vue?vue&type=style&index=0&id=922e279a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922e279a",
  null
  
)

export default component.exports